import React from 'react';
import PropTypes from 'prop-types';

const LegendMobileButton = ({ onClick }) => (
   <button
      className={'legend-mobile-button'}
      onClick={onClick}
      aria-label="Open legend"
   >
      <span/>
   </button>
);

LegendMobileButton.propTypes = {
   onClick: PropTypes.func
};

export default LegendMobileButton;
